import * as React from "react";
import Chip from "@mui/material/Chip";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import type { MenuProps } from "@mui/material/Menu";
import Select, { SelectProps } from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import InfoIcon from "@mui/icons-material/Info";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DoneIcon from "@mui/icons-material/Done";
import {
    GridEditModes,
    GridRenderCellParams,
    GridRenderEditCellParams,
    useGridApiContext,
    useGridRootProps,
} from "@mui/x-data-grid";
import { StyledChip } from "./StatusItemUpoload.style";
import { StatusType } from "../../../../explorer/types/Basket/BasketUploadPartInfo";
import { Tooltip } from "@mui/material";
import AppIconsError from "../../AppIcons/AppIconsError";
import { AppIconsReplaced } from "../../AppIcons";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";

export const STATUS_OPTIONS = ["Open", "PartiallyFilled", "Filled", "Rejected"];

interface StatusProps {
     code: StatusType | ""; message: string 
}


export const Status = React.memo((props: StatusProps) => {
    const { code, message } = props;
    const { t } = useTranslation();
    let icon: any = null;
    let label: string = code === "NONE"? t("basket.uploadbasket.part_valid"):message;
    if (code === "ERROR") {
        icon = <AppIconsError className="icon" />;
        //label = t("basket.uploadbasket.part_not_valid");
    } else if (code === "NOT_ACTIVE") {
        icon = <AppIconsError className="icon" />;
        //label = t("basket.uploadbasket.part_not_active");
    } else if (code === "REPLACED") {
        icon = <AppIconsReplaced className="icon" />;
        //label = t("basket.uploadbasket.part_replaced");
    } else if (code === "NONE") {
        icon = <DoneIcon className="icon" />;
        //label = t("basket.uploadbasket.part_valid");
    }
    
    return (
        <Tooltip title={label} placement="top">
            <StyledChip
                className={code}
                icon={icon}
                size="small"
                variant="outlined"
            />
        </Tooltip>
    );
});



export function renderStatus(params: GridRenderCellParams<any,  { code: StatusType | ""; message: string }>) {
    if (params.value == null || params.value.code == "") {
        return "";
    }

    return <Status code={params.value.code} message={params.value.message} />;
}

